import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-ai-agent }}\n\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/automation/fin-ai-agent/success.hbs" })